const overrideMap = {
    IsDarkModeTheme: 'isDarkModeTheme',
};

export const mapSettingKeysToService = (key: string) => {
    return overrideMap[key as keyof typeof overrideMap] || key;
};
